const H = {
  name: "Singapore",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 3H2V21H8V9H9V21H15V9H16V21H22V3H16V7H8V3ZM6 7H4V5H6V7ZM4 9H6V19H4V9ZM18 9H20V19H18V9ZM20 7H18V5H20V7ZM13 9V19H11V9H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Singapore
};
